import React, { useState } from "react";
import { Box, Typography, Tabs, Tab } from "@mui/material";
import SecurityLogsSubTab from "./SecurityLogsSubTab";
import AdminActivityLogsSubTab from "./AdminActivityLogsSubTab";
import AuditLogsSubTab from "./AuditLogsSubTab";

export default function LogsTab() {
    const [subTab, setSubTab] = useState(0);

    return (
        <Box>
            <Typography variant="h5" gutterBottom>
                System Logs (ISDS Compliance)
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom sx={{ mb: 3 }}>
                Comprehensive audit trail of security events, administrative actions, and data operations.
            </Typography>

            <Tabs value={subTab} onChange={(_, v) => setSubTab(v)} sx={{ mb: 3 }}>
                <Tab label="Security Events" />
                <Tab label="Admin Activities" />
                <Tab label="Audit Trail" />
            </Tabs>

            {subTab === 0 && <SecurityLogsSubTab />}
            {subTab === 1 && <AdminActivityLogsSubTab />}
            {subTab === 2 && <AuditLogsSubTab />}
        </Box>
    );
}
